import angular from 'angular';
import template from './template.html';
import './style.scss';
import {
    TFTSelect,
    TFTSelectConfiguration,
} from '../tft-select';

export class TFTAutosuggest extends TFTSelect {
    value = '';
    innerValue = '';
    options = [];
    filteredOptions = [];

    $onChanges(...args) {
        const { value } = this;

        super.$onChanges(...args);

        this.onInnerOptionValue(angular.copy(value))
    }

    getFilteredOptions(value, options) {
        const preparedValue = (value || '').toString().toLowerCase();

        return (options || []).filter(({ label }) => (label || '').toString().toLowerCase().includes(preparedValue));
    }

    onValueChange(newValue) {
        this.onInnerOptionValue(newValue);
    }

    onOptionClick(option) {
        this.onInnerOptionValue(option.label);

        super.onOptionClick(option);
    }

    onInputFocus() {
        this.setShownState(true);
    }

    onClearClick() {
        this.onInnerOptionValue('');
    }

    onInnerOptionValue(innerValue) {
        this.innerValue = innerValue;
        this.filteredOptions = this.getFilteredOptions(this.innerValue, this.options);
    }
}

export const TFTAutosuggestConfiguration = {
    template,
    bindings: {
        ...TFTSelectConfiguration.bindings,
        isInvalid: '<',
        required: '<',
        onChange: '&',
    },
    controller: TFTAutosuggest,
    controllerAs: 'tftAutosuggestCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftAutosuggest', TFTAutosuggestConfiguration);
